import { ExternalIntegration } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import TableSimple from "ds/components/TableSimple";

import useBackstageTableStore from "./useBackstageTableStore";
import { BACKSTAGE_TABLE_CELLS } from "./Cells";
import { FILTERS_ORDER_SETTINGS_KEY, SORT_CONFIG } from "./constants";

type BackstageIntegrationTableProps = {
  integrations: Array<ExternalIntegration>;
  loadingContent?: boolean;
};

const BackstageIntegrationTable = ({
  integrations,
  loadingContent,
}: BackstageIntegrationTableProps) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimple
      data={integrations}
      loading={loadingContent}
      store={useBackstageTableStore}
      ariaLabel="Backstage integrations table"
      rowsPerPage={10}
      trackAnalytics={trackAnalytics}
      cellPerColumn={BACKSTAGE_TABLE_CELLS}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={SORT_CONFIG}
    />
  );
};

export default BackstageIntegrationTable;
